export enum ProcessingMediaStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
}

export enum ProcessingMediaErrorCode {
    INVALID_FILE = 'INVALID_FILE',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
